import { breadcrumbsContent } from "../breadcrumbs/BreadcrumbsContent";
import useTranslation from "../CustomHooks/useTranslation";
import CheckboxMap from "./CheckboxMap";

interface CheckBoxWithTitleProps {
  title: string;
  CheckBoxArray: string[];
  disabledCheckBox?: string[];
  handelCheckBox: (id: string) => void;
  checkedArray: string[];
  padding?: string;
}
const CheckBoxWithTitle = ({
  title,
  handelCheckBox,
  checkedArray,
  CheckBoxArray,
  padding,
  disabledCheckBox,
}: CheckBoxWithTitleProps) => {
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  return (
    <div dir={notEnglish ? "rtl" : "ltr"}>
      <h1 className={`text-heading3 text-primary_text underline pt-8 pb-4`}>
        {translate(title)}
      </h1>
      <div className={`flex ${padding ? padding : ' pl-1.5 pr-9'} w-full`}>
      {CheckBoxArray.map((item) => (
          <div className="w-[180px]">
            <CheckboxMap
              options={[item]}
              handelCheckBox={handelCheckBox}
              checkedArray={checkedArray}
              className="flex-col"
              disabledCheckBox={disabledCheckBox}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckBoxWithTitle;
